 

export class UploadFileForWorkrequestRequest {
    
    public file: any;
    public fileName: string;
    public buildingId: string;
    public workrequestId: number;
    constructor(init?:Partial<UploadFileForWorkrequestRequest>) {
        
        Object.assign(this, init);
    }
}



// WEBPACK FOOTER //
// ./models/UploadFileForWorkrequestRequest.ts